import React, { useLayoutEffect, useRef, useState } from "react"

import { PpeRequestItem, ColumnConfig } from "../../../types"
import { TableService } from "../../../services"
import { Table } from "simplygrow-ui"
import { TABLE_ROW_HEIGHT } from "../../../constants/table"

interface PpeRequestReturnsProps {
  data: PpeRequestItem[]
  style?: React.CSSProperties
  onItemSelection: (selectedItemIds: string[]) => void
}

const tableService = new TableService()

const PpeRequestReturns = (props: PpeRequestReturnsProps) => {
  const tableRef = useRef<HTMLDivElement>(null)

  const [tableHeight, setTableHeight] = useState<number>(500)

  useLayoutEffect(() => {
    if (tableRef.current) {
      const tableTopY = tableRef.current.getBoundingClientRect().top
      const browserWindowHeight = window.innerHeight
      setTableHeight(browserWindowHeight - tableTopY)
    }
  }, [tableRef.current])

  let tableColumnConfig: ColumnConfig[] = [
    { key: "item", label: "Item", sizeFactor: 1 },
    { key: "sku", label: "SKU", sizeFactor: 1 },
    { key: "size", label: "Size", sizeFactor: 1 },
    // { id: 'qty', label: 'Qty', sizeFactor: 1 },
    // { id: 'reason', label: 'Reason for return', sizeFactor: 1 },
  ]

  const { data, onItemSelection } = props

  const columnConfig = tableService.convertPfColumnConfigToGridColDef(tableColumnConfig)
  return (
    <div ref={tableRef} style={{ width: "100%" }}>
      <Table
        rows={data}
        columns={columnConfig}
        tableHeight={tableHeight}
        rowHeight={TABLE_ROW_HEIGHT}
        rowSelection={true}
        onRowSelection={(selectedRowIds: string[]) => onItemSelection(selectedRowIds)}
      />
    </div>
  )
}

export default PpeRequestReturns
